import React, { useState, useEffect } from 'react';
import { Phone, MessageCircle } from 'lucide-react';

const StickyBookingBar = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const checkVisibility = () => {
            // Show sticky bar after scrolling 300px
            // AND ensure no modal is open (checking for class or overflow hidden)
            const isScrolled = window.scrollY > 300;
            const isModalOpen = document.body.classList.contains('modal-open') || document.body.style.overflow === 'hidden';

            setIsVisible(isScrolled && !isModalOpen);
        };

        const handleScroll = () => {
            checkVisibility();
        };

        // MutationObserver to catch class/style changes on body (like when modal opens)
        const observer = new MutationObserver(() => {
            checkVisibility();
        });

        observer.observe(document.body, { attributes: true, attributeFilter: ['style', 'class'] });

        window.addEventListener('scroll', handleScroll);
        // Initial check
        checkVisibility();

        return () => {
            window.removeEventListener('scroll', handleScroll);
            observer.disconnect();
        };
    }, []);

    if (!isVisible) return null;

    return (
        <div className="fixed bottom-0 left-0 right-0 z-40 animate-slide-up">
            <div className="bg-gradient-to-r from-coffee-900 to-zen-gold shadow-2xl">
                <div className="max-w-7xl mx-auto px-4 py-2 sm:py-3 sm:px-6 lg:px-8">
                    <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
                        {/* Message */}
                        <div className="flex items-center gap-3">
                            <div className="hidden sm:flex items-center justify-center w-12 h-12 bg-white/20 rounded-full">
                                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                            </div>
                            <div className="text-center sm:text-left">
                                <p className="text-white font-bold text-sm sm:text-base">
                                    Professional Home Service Massage • 15+ Years Experience
                                </p>
                                <p className="text-white/90 text-xs hidden sm:block">
                                    10,000+ Satisfied Clients • Same Day Booking Available
                                </p>
                            </div>
                        </div>

                        {/* Action Buttons */}
                        <div className="hidden sm:flex gap-3 w-full sm:w-auto">
                            <a
                                href="tel:+919901853969"
                                className="flex-1 sm:flex-none inline-flex items-center justify-center gap-2 bg-white text-coffee-900 px-6 py-3 rounded-full font-bold hover:bg-cream transition-all duration-300 shadow-lg hover:shadow-xl"
                            >
                                <Phone size={18} />
                                <span className="whitespace-nowrap">Call Now</span>
                            </a>
                            <a
                                href="https://wa.me/919901853969?text=Hi,%20I%20want%20to%20book%20a%20massage%20session"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex-1 sm:flex-none inline-flex items-center justify-center gap-2 bg-green-600 text-white px-6 py-3 rounded-full font-bold hover:bg-green-700 transition-all duration-300 shadow-lg hover:shadow-xl"
                            >
                                <MessageCircle size={18} />
                                <span className="whitespace-nowrap">WhatsApp</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StickyBookingBar;
